import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  @Input() list: any;

  data: any = []

  toggleFolder() {
    this.list.isOpen = !this.list.isOpen;
  }
  constructor() { }

  ngOnInit(): void {

    console.log(typeof this.list)
    if(typeof this.list == "object"){
      this.data.push(this.list)
    }else[
      this.data = this.list
    ]
  }

  openFolder(list: any){
    console.log(list)
    if(list.children != null && list.children != undefined && list.children.length != 0){
      list.isOpen = !list.isOpen
    }
  }

}
